<template>
	<!-- Common Banner Area -->
	<!-- <Banner /> -->

	<!-- Hotel Search Areas -->
	<AlliesResult />

	<!-- Cta Area 
    <Cta />-->
</template>

<script>
	import AlliesResult from "@/components/hotel/AlliesResult.vue";

	export default {
		name: "AllyInterestView",
		components: {
			AlliesResult,
		},
	};
</script>
